import { ManageCommon } from "./base-manager.abstract";
export class AdobeManage extends ManageCommon {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "launchLibId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "adobe-launch-lib"
        });
    }
}
//# sourceMappingURL=adobe-manager.abstract.js.map